import { Type } from "class-transformer";
import { EnaioArchiveImportParams } from "./EnaioArchiveImportParams";
import { ExportStorageHeader } from "./ExportStorageHeader";

export class EnaioImportOptions {
    id: string;
    singleStep = false;
    statusDir: string;
    @Type(() => EnaioArchiveImportParams)
    archives: EnaioArchiveImportParams[];
    @Type(() => ExportStorageHeader)
    header: ExportStorageHeader;
}
